import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MultiLanguageService {
  // Initialize from localStorage immediately so getCurrentLanguage() is correct
  // on the very first call — before app.component.ts calls setLanguage().
  private readonly currentLanguageSubject = new BehaviorSubject<string>(
    (typeof localStorage !== 'undefined' &&
      localStorage.getItem('appLanguage')) ||
      'en',
  );
  currentLanguage$: Observable<string> =
    this.currentLanguageSubject.asObservable();

  constructor(private readonly translate: TranslateService) {}

  /**
   * Sets the application language and notifies subscribers
   * @param language The language code (e.g., 'en', 'ta', 'ml')
   */
  setLanguage(language: string): void {
    this.translate.use(language).subscribe({
      next: () => {
        this.currentLanguageSubject.next(language);
      },
      error: (err) => {
        console.error(`Failed to load language file for: ${language}`, err);
        this.translate.use('en').subscribe(() => {
          this.currentLanguageSubject.next('en');
        });
      },
    });
  }

  /**
   * Gets the current language
   * @returns The current language code
   */
  getCurrentLanguage(): string {
    return this.currentLanguageSubject.getValue();
  }
}
